export default __webpack_public_path__ + "static/media/acceX.933857fc.svg";